import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import React from 'react';

interface IProps {
  companyName: string;
  onSignup: (email: string, password: string) => Promise<void>;
  onBack: () => void;
}

export default function SignupStep(props: IProps) {
  const [loading, setLoading] = useState(false);
  const [passwordValid, setPasswordValid] = React.useState(true);

  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');

  const handleEmailChange = (newEmail: string) => {
    setEmail(newEmail);
  };

  const checkPasswordValid = (str: string) => {
    if (!str.length) {
      return false;
    }
    const hasCapital = /[A-Z]/.test(str);
    const hasLower = /[a-z]/.test(str);
    const hasNumber = /[0-9]/.test(str);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(str);

    const conditionsMet = [hasCapital, hasLower, hasNumber, hasSymbol].filter(Boolean).length;

    return conditionsMet >= 3 && str.length >= 8;
  };

  const handlePasswordChange = (newPass: string) => {
    const isValid = checkPasswordValid(newPass);
    setPass(newPass);
    setPasswordValid(isValid);
  };

  const handleSignup = async () => {
    setLoading(true);
    try {
      await props.onSignup(email, pass);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Typography sx={{ mt: 2, mb: 1 }}>
        Create a Businsess user for the supplier: {props.companyName}{' '}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2, gap: 2 }}>
        <TextField
          type="text"
          name="email"
          label="Email"
          disabled={loading}
          onChange={(e) => handleEmailChange(e.target.value)}
        />

        <TextField
          error={!passwordValid}
          type="text"
          name="password"
          label="Password"
          onChange={(e) => handlePasswordChange(e.target.value)}
          helperText={`8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the special symbols: @ # $ % ^ &amp; * - _ + = [ ] { } | \\ : ' , ? / \` ~ " ( ) ; .`}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button onClick={props.onBack} disabled={loading}>
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button variant="contained" onClick={handleSignup} disabled={loading}>
          Sign Up
        </Button>
      </Box>
    </React.Fragment>
  );
}
